import React from "react";
import { IAdmin } from "../interfaces/admin";

export const UserContext = React.createContext<{
  userData: IAdmin | undefined;
  setUserData: (data: IAdmin | undefined) => void;
  logout: () => void;
}>({
  userData: undefined,
  setUserData: (_: IAdmin | undefined) => {},
  logout: () => {},
});

interface Props {
  children?: JSX.Element;
}

export default function UserStoreProvider(props: Props) {
  const [userData, setUserData] = React.useState<IAdmin>();
  const logout = async () => {
    await localStorage.removeItem("token");
    return window.location.replace("/login");
  };
  return (
    <UserContext.Provider value={{ userData, setUserData, logout }}>
      {props.children}
    </UserContext.Provider>
  );
}

export const useUser = () => React.useContext(UserContext);
